import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Card, Button, Typography } from "antd";
import { OrderedMap, List } from "immutable";
import { Table } from "components";
import moment from "moment";
import { STATE_STATUS } from "../../constants";

const { Paragraph } = Typography;

const GSTIN_FILLING_STATUS_COLS = new OrderedMap({
    return_type: {
        key: "rtntype",
        dataIndex: "rtntype",
        title: "Return Type",
        width: 200,
    },
    financial_year: {
        key: "ret_prd_fn",
        dataIndex: "ret_prd",
        title: "Financial Year",
        width: 200,
        render: _ => {
            const date = moment(_, "MMYYYY");
            if(date.isValid()) {
                const month = date.month();
                const year = date.year();
                if(month < 3) {
                    return `${year-1}-${year}`;
                }
                return `${year}-${year+1}`;
            }
            return "--";
        }
    },
    tax_period: {
        key: "ret_prd",
        dataIndex: "ret_prd",
        title: "Tax Period",
        width: 200,
        render: _ => {
            const date = moment(_, "MMYYYY");
            if(date.isValid()) {
                return date.format("MMM");
            }
            return "--";
        }
    },
    date_of_filling: {
        key: "date_of_filling",
        dataIndex: "dof",
        title: "Date of Filling",
        width: 200,
    },
    status: {
        key: "status",
        dataIndex: "status",
        title: "Status",
        width: 200,
    },
});

class GSTINFillingStatus extends React.Component {
    state = {
        viewDetails: false,
    };
    onViewDetailsToggle = () => {
        this.setState({
            viewDetails: !this.state.viewDetails,
        });
    };

    componentDidUpdate() {
        if(this.state.viewDetails && this.props.gstinFillingDetails.get("status") === STATE_STATUS.UNFETCHED) {
            this.props.fetch(this.props.gstin);
        }
    }

    get isLoading() { 
        return [STATE_STATUS.FETCHING, STATE_STATUS.UPDATING].includes(this.props.gstinFillingDetails.get("status"));
    }
    refresh = () => this.props.refresh(this.props.gstin, this.props.companyId);

    cardExtra = [
        <Button
            key={"refresh-btn"}
            type={"link"}
            size={"small"}
            onClick={this.refresh}
            style={{
                fontSize: 12
            }}
            disabled={this.props.recreditViewOnlyPermission}
        >
            Update
        </Button>
    ]
    render() {
        
        return (
            <React.Fragment>
                <Col span={5} className={"p-10"}>
                    <Card className={"small-card-title"} style={{
                        minHeight: "135px"
                    }} title={"GST Filling Status"} extra={this.cardExtra}>
                        <Row>
                            <Col span={12}>
                                <Paragraph
                                    className={"d-flex justify-content-space-between mb-0"}
                                    level={3}
                                >
                                    {this.props.latestDateOfFilling|| "Not Available"}
                                </Paragraph>
                            </Col>
                            <Col span={12} style={{
                                textAlign: "right"
                            }}>
                                <Button
                                    type={"link"}
                                    size={"small"}
                                    onClick={this.onViewDetailsToggle}
                                    style={{
                                        fontSize: 12
                                    }}
                                >
                                    {   
                                        // eslint-disable-next-line no-constant-condition
                                        (this.props.latestDateOfFilling || true)  ? (!this.state.viewDetails ? "View >" : "< Hide") : null 
                                    }
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </Col>
                {this.state.viewDetails ? (
                    <Col span={24} className={"p-5"}>
                        <Card 
                            className={"small-card-title padless-card"} 
                            title={"GST Filling Status"} 
                        >
                            <Table
                                columns={GSTIN_FILLING_STATUS_COLS}
                                data={this.props.gstinFillingDetails.get("data", List([]))}
                                showTopSection={false}
                                noRowSelection={true}
                                className={"inbox-table"}
                                type={"inner"}
                                loading={this.isLoading}
                            />
                        </Card>
                    </Col>
                ) : null}
            </React.Fragment>
        );
    }
}

GSTINFillingStatus.propTypes = {
    gstinFillingDetails: PropTypes.func,
    latestDateOfFilling: PropTypes.string,
    fetch: PropTypes.func,
    refresh: PropTypes.func,
    gstin: PropTypes.string,
    companyId: PropTypes.number,
    recreditViewOnlyPermission: PropTypes.bool,
};

export default GSTINFillingStatus;